import { Devi_inactivityCheck } from '../Devi/Devi.inactivity'
import type { Base_Bus } from '../Base/Base.Bus'
import { DS_setData } from '../DS/DS.Data'
import { Logg_event } from '../Logg/Logg.event'
import { User_isLoggedIn } from '../User/User.get'
import { Sync_sync } from '../Sync/Sync.initialise'
import { timeout } from '../../../shared/lib/timeout.no-deps'
import { Auth_getStatus } from '../Auth/Auth.State'
import { Plat_saveRecoveryValue } from '../Plat/Plat.androidRecovery'

//
// This is fired when the user switches back to the app on a device
// without having closed it before. It's a good time to bother them
// with updates or re-logging in.
//
export async function Evnt_onResume(bus: Base_Bus, event: CordovaResumeEvent) {
    Logg_event('Start', { label: 'OnResume' })
    DS_setData('ResumeEventFired', (d) => ({
        forcedLogoutCanLogoutWithoutWarning: !User_isLoggedIn(d),
    }))
    await Plat_saveRecoveryValue(event.pendingResult)
    await Devi_inactivityCheck()

    // Make sure that we're not trying to login from handleOpenUrl
    await timeout(300)
    if (Auth_getStatus() !== 'complete') return

    // Otherwise, now's a good time to sync
    await Sync_sync('App resumed', bus)
}
